import { render, staticRenderFns } from "./AgeRange.vue?vue&type=template&id=5c38a763&scoped=true"
import script from "./AgeRange.vue?vue&type=script&lang=js"
export * from "./AgeRange.vue?vue&type=script&lang=js"
import style0 from "./AgeRange.vue?vue&type=style&index=0&id=5c38a763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c38a763",
  null
  
)

export default component.exports